import { CoreAPI, createCommonAuthMethods } from '@hero/sdk-core';

/**
 * Carrier-SDK auth namespace. The unified `signIn` / `signUp` come
 * from {@link createCommonAuthMethods} and target the unified
 * `auth.signIn` / `auth.signUp` endpoints (relations-v2). The legacy
 * carrier-only aliases (`signInCarrier` / `signUpCarrier`) were
 * removed in Phase 5e — the same shape is now reachable through the
 * unified methods. See `docs/relations-v2/08-user-identity.md`.
 */
export function createAuthAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonAuthMethods(coreAPI),
  };
}
